
export function decode(val: string | undefined) {
	return val ? decodeURIComponent(val.replace(/\+/g, '%20')) : val;
}
